import React, { Suspense } from "react";
const Caption = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_figure_caption_lazy" */
    "./viewer-caption.js"
  )
);
const CaptionRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    Caption,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const CaptionLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(CaptionRenderer, { key: node.id, node, ...props }));
};
export {
  CaptionLazy
};
//# sourceMappingURL=caption-renderer-lazy.js.map
